"use client";

import type { TabItem, RowItem, ColumnItem, ValueItem, Form6Config } from "../types";
import RowColumnManager from "./RowColumnManager";
import DataTable from "./DataTable";

interface TabContentProps {
  tab: TabItem;
  rows: RowItem[];
  columns: ColumnItem[];
  config: Form6Config;
  getValue: (tabId: number, rowId: number, colId: number) => ValueItem | null;
  onAddRow: (tabId: number) => void;
  onAddColumn: (tabId: number) => void;
  onDeleteRow: (rowId: number) => void;
  onDeleteColumn: (colId: number) => void;
  onUpdateRowName: (
    rowId: number,
    name: string,
    textColor?: string,
    bgColor?: string,
    borderColor?: string
  ) => void;
  onUpdateColumnName: (
    colId: number,
    name: string,
    textColor?: string,
    bgColor?: string,
    borderColor?: string
  ) => void;
  onUpdateCategoryHeader: (
    tabId: number,
    headerValue: string,
    textColor: string,
    bgColor: string,
    borderColor: string
  ) => void;
  onSaveCell: (
    tabId: number,
    rowId: number,
    colId: number,
    value: string,
    textColor: string,
    bgColor: string,
    borderColor: string
  ) => Promise<boolean>;
}

const TabContent = ({
  tab,
  rows,
  columns,
  config,
  getValue,
  onAddRow,
  onAddColumn,
  onDeleteRow,
  onDeleteColumn,
  onUpdateRowName,
  onUpdateColumnName,
  onUpdateCategoryHeader,
  onSaveCell,
}: TabContentProps) => {
  return (
    <div className="p-4 space-y-4">
      {/* Row & Column Management */}
      <RowColumnManager
        tabId={tab.id}
        rows={rows}
        columns={columns}
        config={config}
        onAddRow={onAddRow}
        onAddColumn={onAddColumn}
        onDeleteRow={onDeleteRow}
        onDeleteColumn={onDeleteColumn}
        onUpdateRowName={(rowId, name) => onUpdateRowName(rowId, name)}
        onUpdateColumnName={(colId, name) => onUpdateColumnName(colId, name)}
      />

      {/* Data Table */}
      <DataTable
        tab={tab}
        rows={rows}
        columns={columns}
        config={config}
        getValue={getValue}
        onUpdateCategoryHeader={onUpdateCategoryHeader}
        onUpdateColumnName={onUpdateColumnName}
        onUpdateRowName={onUpdateRowName}
        onSaveCell={onSaveCell}
      />
    </div>
  );
};

export default TabContent;

